export default {"src":"/_next/static/media/EmptyNotePad.8c4b3255.svg","height":165,"width":202,"blurWidth":0,"blurHeight":0};